import { tools } from './../helpers/tools';

class Ajax {
    static execute(context, type, url, withCredentials, data) {        
        if (!tools.validateApi(context)) {
            return Promise.reject();
        }

        return new Promise((resolve, reject) => {
            const options = {
                url: `${context.url.domain}${context.url.path}${(url ? url : '')}`,
                type: type,
                dataType: 'json',
                xhrFields: null,
                data: data,
                cache: false,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }

            if (withCredentials) {
                options.xhrFields = {
                    withCredentials: true,
                };
            }

            $.ajax(options).done((response) => {
                resolve(response);
            }).fail((error) => {                
                if (error.responseText) {
                    // Fix issue with jQuery parsing responseText
                    error.responseText = (error.responseJSON && error.responseJSON.Message)
                        ? error.responseJSON.Message.replace(/\./g, '')
                        : null;
                }

                reject(error);
            });
        });
    }

    static get(context, url, withCredentials, data) {
        return this.execute(context, 'GET', url, withCredentials, data);
    }

    static post(context, url, withCredentials, data) {
        return this.execute(context, 'POST', url, withCredentials, data);
    }

    static delete(context, url, withCredentials, data) {
        return this.execute(context, 'DELETE', url, withCredentials, data);
    }

    static put(context, url, withCredentials, data) {
        return this.execute(context, 'PUT', url, withCredentials, data);
    }
}

export default Ajax;


// WEBPACK FOOTER //
// ./scripts/booking/api/ajax.js